import React from 'react';
import PropTypes from 'prop-types';
import { StateLabel } from '@common/components';

export const COLOR_STYLE_MAP = {
  OPEN: 'grass',
  ON_HOLD: 'sun-darker',
  FILLED: 'elm',
  CANCELLED: 'coral',
  PENDING: '',
  REJECTED_BY_APPROVER: 'coral',
};

export const LABEL_OVERWRITE = {
  OPEN: 'Open',
  ON_HOLD: 'On Hold',
  FILLED: 'Filled',
  CANCELLED: 'Cancelled',
  PENDING: 'Pending',
  REJECTED_BY_APPROVER: 'Not Approved',
};

export function StaffingRequestState({ state }) {
  return (
    <StateLabel
      state={LABEL_OVERWRITE[state] || state}
      color={COLOR_STYLE_MAP[state]}
    />
  );
}

StaffingRequestState.propTypes = {
  state: PropTypes.string.isRequired,
};
